var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgShortRuinbet = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.7665 32.0535C65.2055 32.0535 71.2361 25.9997 71.2361 18.5319C71.2361 11.0641 65.2055 5.01025 57.7665 5.01025C50.3274 5.01025 44.2969 11.0641 44.2969 18.5319C44.2969 25.9997 50.3274 32.0535 57.7665 32.0535Z",
    fill: "#3892CF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M47.5781 13.3033C47.5781 11.8109 47.7976 10.3686 48.2067 9.00641C50.6512 6.53245 54.0336 5 57.7651 5C65.1984 5 71.2347 11.0497 71.2347 18.5216C71.2347 21.8069 70.0674 24.8217 68.1218 27.1655C66.3857 27.8766 64.4899 28.2672 62.4945 28.2672C54.2531 28.2672 47.5781 21.5665 47.5781 13.2933V13.3033Z",
    fill: "url(#paint0_linear_10333_61195)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2308 73.6098C73.2308 73.6098 88.7458 55.5809 80.7738 46.5364C73.7696 38.5837 16 28.8682 16 28.8682C16.9479 45.4146 59.3422 66.7788 73.2208 73.6198L73.2308 73.6098Z",
    fill: "#054C72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2308 73.6098C73.2308 73.6098 88.7458 55.5809 80.7738 46.5364C73.7696 38.5837 16 28.8682 16 28.8682C17.6064 41.7087 59.1825 67.3798 73.2208 73.6198L73.2308 73.6098Z",
    fill: "#3892CF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28.8682C16 28.8682 73.7696 38.5837 80.7738 46.5465C88.7358 55.5909 73.2308 73.6198 73.2308 73.6198C73.2308 73.6198 78.5688 55.7512 16.01 28.8682H16Z",
    fill: "url(#paint1_linear_10333_61195)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5742 76.7349L29.6289 57.5542C29.6289 57.5542 37.1719 82.1736 53.525 94.1728C53.525 94.1728 63.3727 87.4921 71.5742 76.7349Z",
    fill: "#3892CF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6289 57.5542L71.5742 76.7349C71.225 77.1956 70.8758 77.6363 70.5166 78.087C62.385 74.0506 29.6289 57.5642 29.6289 57.5642V57.5542Z",
    fill: "#054C72"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6621 85.6389C41.4422 71.2959 29.6289 57.564 29.6289 57.564L71.5742 76.7447C68.9801 80.1501 66.2263 83.1449 63.6621 85.6489V85.6389Z",
    fill: "url(#paint2_linear_10333_61195)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10333_61195",
    x1: 71.3245,
    y1: 5.76122,
    x2: 41.555,
    y2: 33.4312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D1D1",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#797979",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#383838",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#101010",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#010101",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10333_61195",
    x1: 72.2929,
    y1: 26.4243,
    x2: 35.27,
    y2: 59.3653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D1D1",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#797979",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#383838",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#101010",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#010101",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10333_61195",
    x1: 53.4252,
    y1: 62.5019,
    x2: 39.1774,
    y2: 85.7703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#D1D1D1",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#797979",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#383838",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#101010",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#010101",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShortRuinbet);
export default ForwardRef;